import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "bin",
  "description": "turbo bin 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo 바이너리의 경로를 가져옵니다."
  }, {
    "heading": "",
    "content": "전역 turbo를 사용하는 경우, 이것은 전역 turbo 바이너리의 경로입니다. turbo를 설치하는 데 사용한 패키지 매니저의 전역 디렉토리 경로를 볼 수 있습니다."
  }, {
    "heading": "",
    "content": "로컬 turbo를 사용하는 경우, 이것은 로컬 turbo 바이너리의 경로입니다. turbo가 저장소에 설치된 경우, node_modules의 경로일 가능성이 높습니다."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 바이너리의 경로를 가져옵니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " bin"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: _jsxs(_components.strong, {
          children: ["전역 ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), "를 사용하는 경우, 이것은 전역 ", _jsx(_components.code, {
        children: "turbo"
      }), " 바이너리의 경로입니다. ", _jsx(_components.code, {
        children: "turbo"
      }), "를 설치하는 데 사용한 패키지 매니저의 전역 디렉토리 경로를 볼 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/getting-started/installation#repository-installation",
        children: _jsxs(_components.strong, {
          children: ["로컬 ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), "를 사용하는 경우, 이것은 로컬 ", _jsx(_components.code, {
        children: "turbo"
      }), " 바이너리의 경로입니다. ", _jsx(_components.code, {
        children: "turbo"
      }), "가 저장소에 설치된 경우, ", _jsx(_components.code, {
        children: "node_modules"
      }), "의 경로일 가능성이 높습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
